import moveSmoothly from '@component_path/lib/moveSmoothly';

document.addEventListener('DOMContentLoaded', () => {
  const topBtn = document.querySelector('.m3p-pagetop');

  if(topBtn){
    topBtn.style.bottom = '-80px';
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 400) {
        topBtn.style.bottom = '80px';
      } else {
        topBtn.style.bottom = '-80px';
      }
    });
  }

  moveSmoothly('.m3p-pagetop a', '#page-top');
});